module.exports = __webpack_public_path__ + "static/media/feminine-hygiene.8eb35381.webp";